import { listTyresApi } from '../../../api/endpoints';

// Season display labels
const SEASON_LABELS = {
  summer: 'Letne',
  winter: 'Zimske',
  allSeason: 'Celoletne',
};

/**
 * Maps API tyre data to the pricelist component format
 */
const mapTyreToPricelistFormat = (tyre) => ({
  id: tyre._id,
  dimension: tyre.dimensions || '',
  model: tyre.name || tyre.design || '',
  bruto: tyre.grossPrice || 0,
  neto: tyre.netPrice || 0,
  brutoZPopustom: tyre.discountGrossPrice || 0,
  catalogNumber: tyre.catalogNumber,
  ean: tyre.ean,
});

/**
 * Maps API season name to internal season key
 */
const getSeasonKey = (seasonName) => {
  if (!seasonName) return null;
  const name = seasonName.toLowerCase();
  if (name === 'summer') return 'summer';
  if (name === 'winter') return 'winter';
  if (name === 'all-season' || name === 'all season' || name === 'allseason') return 'allSeason';
  return null;
};

/**
 * Groups tyres by brand and season into pricelist structure
 */
const groupTyresIntoPricelists = (tyres) => {
  const pricelists = {};
  const brandsSet = new Set();
  const seasonsSet = new Set();

  tyres.forEach((tyre) => {
    const brandName = tyre.brand?.name;
    const seasonName = tyre.season?.name;
    const seasonKey = getSeasonKey(seasonName);

    // Skip tyres without brand or valid season
    if (!brandName || !seasonKey) {
      return;
    }

    brandsSet.add(brandName);
    seasonsSet.add(seasonKey);

    const key = `${brandName}-${seasonKey}`;

    if (!pricelists[key]) {
      pricelists[key] = {
        brand: brandName,
        season: seasonKey,
        seasonLabel: SEASON_LABELS[seasonKey] || seasonKey,
        tyres: [],
      };
    }

    pricelists[key].tyres.push(mapTyreToPricelistFormat(tyre));
  });

  // Sort brands alphabetically
  const brands = Array.from(brandsSet).sort();
  
  // Sort seasons in logical order
  const seasonOrder = ['summer', 'winter', 'allSeason'];
  const seasons = Array.from(seasonsSet).sort(
    (a, b) => seasonOrder.indexOf(a) - seasonOrder.indexOf(b)
  );

  return { pricelists, brands, seasons };
};

/**
 * Fetches all tyres from API and groups them into pricelists
 */
const fetchPricelists = async () => {
  const allTyres = [];
  let offset = 0;
  const limit = 250;
  let hasMore = true;

  // Fetch all tyres with pagination
  while (hasMore) {
    const results = await listTyresApi({
      limit,
      offset,
      populate: 'brand,season',
    });

    if (results && results.length > 0) {
      allTyres.push(...results);
      offset += limit;
      hasMore = results.length >= limit;
    } else {
      hasMore = false;
    }
  }

  return groupTyresIntoPricelists(allTyres);
};

export default fetchPricelists;
